import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'secondsToTimerValue'
})
export class SecondsToTimerValuePipe implements PipeTransform {

  transform(timeInSeconds: number, ...args: unknown[]): unknown {
    const hours = Math.floor(timeInSeconds / 3600);
    let minutes: string | number = Math.floor(timeInSeconds / 60 % 60);
    minutes = minutes <= 9 ? '0' + minutes : minutes;
    let seconds: string | number = timeInSeconds % 60;
    seconds = seconds <= 9 ? '0' + seconds : seconds;

    if (hours && hours !== 0) {
      return hours + ':' + minutes + ':' + seconds;
    } else {
      return minutes + ':' + seconds;
    }
  }
}
